module.exports = __webpack_public_path__ + "img/polar-bear.d4ec43f5.png";